import cloneDeep from 'lodash/cloneDeep';
import set from 'lodash/set';
import get from 'lodash/get';
import { mapState } from 'vuex';
import TwinMapMarkerColorPickerMenu from './twinMapMarkerColorPickerMenu.vue';
import twinFields from '../twinFields';
import apiService from '@/services/apiService/dashboards';
import debounce from 'lodash/debounce';
export default {
  name: 'TwinMapMarkerOptionsEditor',
  components: {
    TwinMapMarkerColorPickerMenu
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    dashboardId: {
      type: String,
      required: true
    },
    customParameters: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      isFetchingAvailableStates: true,
      availableStates: []
    };
  },
  computed: {
    ...mapState('app', ['color', 'inpOutlined', 'inpFilled']),
    colorRules() {
      return this.getByKey('twinMapOptions.rules', []);
    },
    ruleOperators() {
      const operators = ['eq', 'neq', 'gt', 'gte', 'lt', 'lte'];
      return operators.map(operator => ({
        text: this.$t(`Dashboards.components.twinMap.markerOptionsEditor.inputs.rule.operator.options.${operator}`),
        value: operator
      }));
    },
    twins() {
      return cloneDeep(get(this.data, 'twin-map', []));
    },
    entityFilters() {
      return {
        twinFilter: get(this.value, 'twinFilter', {}),
        virtualDeviceFilter: get(this.value, 'virtualDeviceFilter', {})
      };
    },
    ruleFields() {
      const fields = twinFields.getDefinitions(this.$t, this.twins);
      const staticAttributes = Object.entries(fields).map(([key, value]) => ({
        text: get(value, 'defaultLabel'),
        value: key
      }));
      const stateAttributes = this.availableStates.filter((state, index, self) => self.findIndex(s => s.key === state.key) === index).map(state => ({
        text: this.$t('Dashboards.twinFields.defaultLabel.state', {
          state: state.key
        }),
        value: `state.${state.key}`
      })).sort((a, b) => {
        return a.text.localeCompare(b.text);
      });
      return [...staticAttributes, ...stateAttributes];
    }
  },
  watch: {
    entityFilters: {
      async handler() {
        this.fetchAvailableStates();
      },
      immediate: true
    },
    colorRules: {
      handler: function () {
        this.colorRules.forEach((rule, ruleIndex) => {
          if (!rule.color) {
            this.setByKey(`twinMapOptions.rules[${ruleIndex}].color`, this.color);
          }
        });
      },
      immediate: true
    }
  },
  methods: {
    getByKey(key, defaultValue) {
      return get(this.value, key, defaultValue);
    },
    setByKey(key, value) {
      const clone = cloneDeep(this.value);
      set(clone, key, value);
      this.$emit('input', clone);
    },
    updateRule(ruleIndex, key, value) {
      this.setByKey(`twinMapOptions.rules[${ruleIndex}][${key}]`, value);
    },
    addEmptyRule() {
      const clonedRules = cloneDeep(this.getByKey('twinMapOptions.rules', []));
      clonedRules.push({
        field: null,
        operator: 'eq',
        value: null,
        color: this.color
      });
      this.setByKey('twinMapOptions.rules', clonedRules);
    },
    removeRule(ruleIndex) {
      const clonedRules = cloneDeep(this.getByKey('twinMapOptions.rules', []));
      clonedRules.splice(ruleIndex, 1);
      this.setByKey('twinMapOptions.rules', clonedRules);
    },
    fetchAvailableStates: debounce(function () {
      this.isFetchingAvailableStates = true;
      this.actuallyFetchAvailableStates();
    }, 500),
    async actuallyFetchAvailableStates() {
      try {
        this.isFetchingAvailableStates = true;
        const result = await apiService.fetchAvailableStatesForDashboardFilter(this.dashboardId, this.entityFilters.twinFilter, this.entityFilters.virtualDeviceFilter, this.customParameters);
        this.availableStates = result;
      } catch (e) {
        this.$snack(this.$t('Dashboards.components.widgetTwinTableOptionsEditor.snack.error.couldNotFetchAvailableStates', {
          error: e.message
        }), 'error');
        console.error(e);
      } finally {
        this.isFetchingAvailableStates = false;
      }
    }
  }
};